<template>
  <section v-bind:class="{'hover' : menuHover, 'opened' : navOpened}">
    <a
      @click="navToggle"
      @mouseenter="navMouseEnter"
      @mouseleave="navMouseLeave"
      class="menu-btn"
      v-bind:class="{'hover' : menuHover, 'opened' : navOpened, 'inside' : menuInHeader}"
    >
      <span class="ceiling"></span>
      <span class="floor"></span>
    </a>
    <nav>
      <ul>
        <li
          v-for="(navItem, index) in navItems"
          :key="index"
          class="nav-item"
          v-bind:class="{'dim' : navItemHover, 'hover' : navItem.hover}"
          @mouseenter="navItemMouseEnter(index)"
          @mouseleave="navItemMouseLeave(index)"
        >
          <router-link :to="{ path: navItem.routePath }" @click.native="navItemClick" :exact="navItem.exactPath">
            <h1>{{ navItem.label }}</h1>
            <em>{{ navItem.description }}</em>
          </router-link>
        </li>
      </ul>
    </nav>
  </section>
</template>

<script>
import {TweenMax, TimelineMax, Power2, Power4} from 'gsap'

export default {
  name: 'sidenav',
  data () {
    return {
      menuHover: false,
      navOpened: false,
      navTransitionTl: null,
      navItems: [
        {
          label: 'Home',
          description: 'The first page.',
          routePath: '/',
          exactPath: true,
          hover: false
        },
        {
          label: 'Works',
          description: 'Selected projects.',
          routePath: '/works',
          exactPath: false,
          hover: false
        },
        {
          label: 'Photos',
          description: 'Pictures I took.',
          routePath: '/photos',
          exactPath: false,
          hover: false
        },
        {
          label: 'About',
          description: 'Quick brief about myself.',
          routePath: '/about',
          exactPath: false,
          hover: false
        }
      ],
      navItemHover: false
    }
  },
  computed: {
    menuInHeader () {
      return this.$store.state.menuBtnInHeader
    }
  },
  methods: {
    navToggle (event) {
      this.navOpened = !this.navOpened
      document.getElementById('matters').classList.toggle('opened')

      if (this.navOpened) {
        this.navTransitionTl.restart()
      } else {
        setTimeout(() => {
          if (this.navOpened === false) {
            TweenMax.set('.nav-item', {display: 'none'})
          }
        }, 400)
      }
    },
    navMouseEnter (event) {
      this.menuHover = true
    },
    navMouseLeave (event) {
      this.menuHover = false
    },
    navItemMouseEnter (i) {
      this.navItemHover = true
      this.navItems[i].hover = true
    },
    navItemMouseLeave (i) {
      this.navItemHover = false
      this.navItems[i].hover = false
    },
    navItemClick (event) {
      this.navOpened = !this.navOpened
      document.getElementById('matters').classList.toggle('opened')
      setTimeout(() => {
        if (this.navOpened === false) {
          TweenMax.set('.nav-item', {display: 'none'})
        }
      }, 400)
    }
  },
  mounted () {
    TweenMax.set('.nav-item', {display: 'none'})

    this.navTransitionTl = new TimelineMax({paused: true})
    this.navTransitionTl.set('.nav-item', {display: 'block'})
    this.navTransitionTl.staggerFromTo('.nav-item h1', 1.2, {opacity: 0}, {opacity: 1, ease: Power2.easeOut, force3D: true}, 0.1, 0)
    this.navTransitionTl.staggerFromTo('.nav-item h1', 1, {x: 200}, {x: 0, ease: Power4.easeOut, force3D: true}, 0.05, 0)
    this.navTransitionTl.staggerFromTo('.nav-item em', 1.2, {opacity: 0}, {opacity: 0.2, ease: Power2.easeOut, force3D: true}, 0.1, 0.3)
    this.navTransitionTl.staggerFromTo('.nav-item em', 1, {x: 20}, {x: 0, ease: Power4.easeOut, force3D: true}, 0.05, 0.3)
  }
}
</script>

<style lang="scss" scoped>
  section {
    width: 60px;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    overflow: hidden;
    z-index: 10;
    transition: all 0.4s cubic-bezier(.43,.24,.3,1);

    &.hover {
      background-color: $color-black;

      @include device(tablet) {
        background-color: transparent;
      }
    }

    &.opened {
      width: 300px;
      background-color: $color-black;

      @include device(mobile) {
        width: 100%;
      }
    }
  }

  .menu-btn {
    width: 60px;
    height: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    position: fixed;
    right: 0;
    top: 50%;
    margin-top: -30px;
    z-index: 10;
    transition: all 0.3s cubic-bezier(.59,.63,.13,1.47);
    transition-property: transform, opacity;

    @include device(mobile) {
      position: absolute;
      top: 0;
      right: 0;
      margin: 0;
      width: 50px;
      height: 50px;
    }

    & span {
      display: block;
      width: 30px;
      height: 2px;
      background: $color-black;
      position: relative;
      transition: all 0.2s cubic-bezier(.59,.63,.13,1.47);

      @include device(mobile) {
        width: 26px;
      }

      &.ceiling {
        margin-bottom: 4px;

        @include device(mobile) {
          margin-bottom: 3px;
        }
      }

      &.floor {
        margin-top: 4px;

        @include device(mobile) {
          margin-top: 3px;
        }
      }
    }

    &.hover {
      & span {
        background-color: #fff;

        @include device(tablet) {
          background-color: $color-black;
        }
      }
    }

    &.opened , &.inside{
      & span {
        background-color: #fff;
      }
    }

    &.opened {
      opacity: 0.5;
      transform: rotate(45deg);

      &.hover {
        opacity: 1;
      }

      & .ceiling {
        margin-bottom: -1px;
        transform: rotate(90deg);
      }

      & .floor {
        margin-top: -1px;
      }
    }
  }

  nav {
    height: 100%;
    display: flex;
    justify-content: center;
    opacity: 0;
    transition: all 0.2s linear;

    .opened & {
      opacity: 1;
    }

    & ul {
      display: flex;
      flex-direction: column;
      justify-content: center;

      & li {
        width: 180px;
        padding: 1.2rem 0;
        cursor: pointer;
        transition: opacity 0.1s linear;

        @include device(mobile) {
          padding: 20px 0;
        }

        &.dim {
          opacity: 0.3;

          &.hover {
            opacity: 1;
          }
        }

        & a {
          &:before {
            display: block;
            content: "";
            width: 15px;
            height: 20px;
            background-image: url('/static/image/icon-triangle-right.svg');
            background-size: contain;
            background-repeat: no-repeat;
            background-position: left;
            position: absolute;
            left: 0;
            margin-left: -2px;
            margin-top: 25px;
            opacity: 0;
            transition: opacity 1s linear;
          }

          &.router-link-active {
            &:before {
              opacity: 1;
            }
          }
        }

        & h1 {
          font-size: 1.8rem;
          letter-spacing: -0.05rem;
          line-height: 4rem;
          color: #fff;
        }

        & em {
          display: block;
          color: #fff;
          font-size: 0.9rem;
          line-height: 1rem;
          opacity: 0.2;
          font-style: normal;
        }
      } // li
    } // ul
  }
</style>



// WEBPACK FOOTER //
// src/components/Sidenav.vue